import angular from 'angular';

import easyshipInput from '@client/core/components/forms/input';
import easyshipButton from '@client/core/components/buttons/button';
import easyshipSelect from '@client/core/components/forms/select';
import mixpanelService from '@client/core/services/mixpanel';

import '@client/app/factories/GoogleAnalytics/GoogleAnalytics.service';
import '@client/app/services/AbTestsService/AbTestsService.service';

import { SignupComponent } from './signup.component';

const legacyModules = ['app.factory.GoogleAnalytics'];

const module = angular
  .module('auth.signup', [
    easyshipInput,
    easyshipButton,
    easyshipSelect,
    mixpanelService,
    'app.service.AbTestsService',
    ...legacyModules,
  ])
  .component('signup', SignupComponent);

export { module };
